<template>
  <div class="totaldata-w">
    <div class="content">
      <div class="head">
        <span class="title">{{ title }}</span>
      </div>

      <div v-if="data" class="bottom x_y_center" :title="data+(unit || '')">
        <span class="span_1 text_ellipsis">{{ data }}</span>
        <span class="unit">{{ unit }}</span> </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: String,
    unit: String,
    data: null
  },
  computed: {

  }

}
</script>

<style lang="scss" scoped>
.totaldata-w {
  position: relative;
  width: 246px;
  height: 118px;
  background: rgba($color: #343265, $alpha: .5) url("../assets/images/bigdata_4.png") center center/contain no-repeat;

  & > .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 16px 0 24px 0;
    box-sizing: border-box;
    & > .head {
      margin: 0 auto;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #9BB5FF;
      }

    }

    & > .bottom {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      letter-spacing: 1px;
      text-align: center;
      font-size: 36px;
      font-family: Impact;
      font-weight: 400;
      color: #ffffff;
    }

    .unit{
      font-size: 22px;
      margin: 0 0 0 5px;
    }
  }

  .span_1{
    display: inline-block;
    max-width: 170px;
  }
}
</style>
